import React, { useState } from 'react';
import PageHeader from './components/PageHeader';
import PageFooter from './components/PageFooter';
import Listings from './components/Listings';
import BookmarkUnit from './components/BookmarkUnit';
import './App.css';
import {
  HashRouter as Router,
  Route
} from 'react-router-dom';


export default function App(props) {
  const [filters, setFilters] = useState([]);
  return (
    <>
      <PageHeader />
      {/* <Listings /> */}
      <Router>
        <div>
            <Route
              path='/bookmark/:id'
              component={BookmarkUnit}
            />
             <Route exact path='/' render={(props) => <Listings filters={filters} setFilters={setFilters}/>} />
        </div>
      </Router>
    </>
  );
}
